module.exports = __webpack_public_path__ + "img/GHA.12ae8511.svg";